import React, { useEffect, useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import axios from 'axios';
import { toast } from 'react-toastify';


function Header2({ title }) {
    const redirect = useNavigate();
    const userlogout = () => {
        localStorage.removeItem("userid");
        localStorage.removeItem("userName");
        localStorage.removeItem("useremail");
        toast.success("logout is success");
        redirect("/login");
        return false;
    };

    useEffect(() => {
        fetch();
    }, []);


    const [data, setData] = useState([]);
    const fetch = async () => {
        const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/categories_get`);
        setData(res.data);
    };
    return (
        <div>
            <link href="img/favicon.ico" rel="icon"></link>
            <div className="container-fluid bg-light d-none d-lg-block">
                <div className="row py-2 px-lg-5">
                    <div className="col-lg-6 text-left mb-2 mb-lg-0">
                        <div className="d-inline-flex align-items-center">
                            <small><i className="fa fa-phone-alt mr-2" />+91 9106856105</small>
                            <small className="px-3">|</small>
                            <small><i className="fa fa-envelope mr-2" />support@rajvicosmeticclinic.com</small>
                        </div>
                    </div>
                    <div className="col-lg-6 text-right">
                        <div className="d-inline-flex align-items-center">
                            <NavLink to="/profile" className=' mx-2'>
                                {(
                                    () => {
                                        if (localStorage.getItem("userid")) {
                                            return (
                                                <>
                                                    <span> <i className='fa fa-user'></i> My Account / Hi...{localStorage.getItem("userName")}</span>
                                                </>
                                            )
                                        }
                                    }
                                )()}

                            </NavLink>
                            <a className="text-primary px-2" href='https://www.facebook.com/profile.php?id=100093401964815'>
                                <i className="fab fa-facebook-f" />
                            </a>
                            <a className="text-primary px-2" href='https://www.instagram.com/rajvicosmeticclinic'>
                                <i className="fab fa-instagram" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {/* Topbar End */}
            {/* Navbar Start */}
            <div className="container-fluid p-0">
                <nav className="navbar navbar-expand-lg bg-white navbar-light py-3 py-lg-0 px-lg-5">
                    <NavLink to="/" className="navbar-brand ml-lg-3">
                        <h1 className="m-0 text-primary"><span className="text-dark">Rajvi </span>  Cosmetic Clinic</h1>
                    </NavLink>
                    <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse justify-content-between px-lg-3" id="navbarCollapse">
                        <div className="navbar-nav m-auto py-0">
                            <NavLink to="/" className="nav-item nav-link">Home</NavLink>
                            <NavLink to="/about" className="nav-item nav-link">About</NavLink>
                            <div className="nav-item dropdown">
                                <a href="#" className="nav-link dropdown-toggle" data-toggle="dropdown">Services</a>
                                <div className="dropdown-menu rounded-0 m-0">
                                    {
                                        (data.length > 0) ? data.map((value, key) => {
                                            return (
                                                <>
                                                    <NavLink id={key} to={'/services_details/' + value.id} className="dropdown-item" style={{ color: "black" }}>{value.cate_name}</NavLink>
                                                </>
                                            )
                                        }) : null
                                    }
                                    {/* <NavLink to="/view_service" className="dropdown-item">Hair wash Spa</NavLink>
                                    <NavLink to="/gallery" className="dropdown-item">Gallery</NavLink> */}
                                </div>
                            </div>
                            <NavLink to="/blog" className="nav-item nav-link">Blog</NavLink>
                            <NavLink to="/contact" className="nav-item nav-link">Contact</NavLink>
                        </div>

                        {(() => {
                            if (localStorage.getItem("userid")) {
                                return (
                                    <>
                                        <a href="javascript:void(0)" onClick={userlogout}>
                                            <i className="btn btn-primary mx-2">Logout</i>
                                        </a>
                                    </>
                                )
                            }
                            else {
                                return (
                                    <>
                                        <NavLink to="/login">
                                            <button className="btn btn-primary mx-2">Login</button>
                                        </NavLink>
                                    </>)
                            }
                        })()}
                    </div>
                </nav>
            </div>
            {/* Navbar End */}
            {/* Header Start */}
            <div className="jumbotron jumbotron-fluid bg-jumbotron" style={{ marginBottom: 90 }}>
                <div className="container text-center py-5">
                    <h3 className="text-white display-3 mb-4">{title}</h3>
                    <div className="d-inline-flex align-items-center text-white">
                        <p className="m-0"><a className="text-white" >Home</a></p>
                        <i className="far fa-circle px-3" />
                        <p className="m-0">{title}</p>
                    </div>
                </div>
            </div>
            {/* Header End */}
        </div>

    )
}

export default Header2